'use strict';

import VideoPlayTrigger from "../../../frontend/js/video-play-trigger";

class FocusAreasVideoPlayer extends VideoPlayTrigger {
    constructor() {
        super({ triggerSelector: '.focus-area-video__play-trigger', imageSelector: '.focus-area-video__image' });
    }
}
document.addEventListener("DOMContentLoaded", function () {
    new FocusAreasVideoPlayer();
});